const APROBADA = 'APRO'
const CERRADA = 'CERR'
const ABIERTA = 'ABIE'
const RECHAZADA = 'RECH'

const __dictionary = {
  [APROBADA]: {
    id: APROBADA,
    nombre: 'APROBADA'
  },
  [CERRADA]: {
    id: CERRADA,
    nombre: 'CERRADA'
  },
  [ABIERTA]: {
    id: ABIERTA,
    nombre: 'ABIERTA'
  },
  [RECHAZADA]: {
    id: RECHAZADA,
    nombre: 'RECHAZADA'
  }
}

const __array = [
  __dictionary[APROBADA],
  __dictionary[CERRADA],
  __dictionary[ABIERTA],
  __dictionary[RECHAZADA]
]

const __vaues = [APROBADA, CERRADA, ABIERTA, RECHAZADA]

export default Object.freeze({
  APROBADA,
  CERRADA,
  ABIERTA,
  RECHAZADA,
  __dictionary,
  __array,
  __vaues
})
